import React, { Component } from 'react';
import styled from 'styled-components';
import CloseIcon from '../Assets/close.svg';

const CloseContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  fill: ${props => props.theme.colors.blue};
`;

const CloseIconStyled = styled(CloseIcon)`
  cursor: pointer;
  
  &:hover {
    opacity: .9;
  }
`;

class Closer extends Component {
  render() {
    return (
      <CloseContainer>
        <CloseIconStyled onClick={() => this.props.setInfoboxContent(false)} />
      </CloseContainer>
    );
  }
}

export default Closer;
